import './ResourcesMenuView.scss';
import * as angular from 'angular';
import permissions from 'application/detail/permissions.json';
import ResourceMenuView from './ResourceMenuView.html';
import ResourceView from './resources/ResourceView.html';
import MessageTemplateView from './messageTemplates/MessageTemplateView.html';
import { ResourceCardComponent } from './resources/ResourceCard/index';
import { UnavailableWarningComponent } from './messageTemplates/unavailableWarning/unavailableWarning.component';
import { ResourceController } from './resources/ResourceController';
import { MessageTemplateController } from './messageTemplates/MessageTemplateController';
import { CreateMessageTemplateSidebarController } from './messageTemplates/createMessageTemplateSidebar/CreateMessageTemplateSidebarController';
import { ResourceService } from './resources/ResourceService';
import { MessageTemplateSegmentService } from './messageTemplates/MessageTemplateSegmentService';
import { MessageTemplateService } from './messageTemplates/MessageTemplateService';
import { AiAgentService } from 'modules/application/misc/AiAgentService';
import { MessageTemplateItemComponent } from './messageTemplates/messageTemplateItem';
import { StatusTagComponent } from './messageTemplates/statusTag/statusTag.component';
import { MessageTemplateCardComponent } from './messageTemplates/messageTemplateCard/MessageTemplateCardController';
import { MessageTemplateAttachmentCardComponent } from './messageTemplates/messageTemplateAttachmentCard/MessageTemplateAttachmentCardController';
import { MessageTemplatePaymentCardComponent } from './messageTemplates/messageTemplatePaymentCard/messageTemplatePaymentCardController';
import { MessageTemplateCarouselCardComponent } from './messageTemplates/messageTemplateCarouselCard/messageTemplateCarouselCardController';
import { MessageTemplateButtonsComponent } from './messageTemplates/messageTemplateButtons/MessageTemplateButtonsController';
import { MessageTemplateUtil } from './messageTemplates/MessageTemplateUtil';
import { MessageTemplateSampleModalController } from './messageTemplates/messageTemplateSamples/MessageTemplateSampleModalController';
export const DETAIL_CONTENTS_PATH = 'auth.application.detail.contents';
export const DETAIL_CONTENTS_MESSAGE_TEMPLATES_PATH = 'auth.application.detail.contents.messagetemplate';
export const DETAIL_CONTENTS_RESOURCES_PATH = 'auth.application.detail.contents.resources';
export default angular
    .module('application.contents', [])
    .component('resourceCard', ResourceCardComponent)
    .component('unavailableWarning', UnavailableWarningComponent)
    .component('messageTemplateItem', MessageTemplateItemComponent)
    .component('statusTag', StatusTagComponent)
    .component('messageTemplateCard', MessageTemplateCardComponent)
    .component('messageTemplateAttachmentCard', MessageTemplateAttachmentCardComponent)
    .component('messageTemplatePaymentCard', MessageTemplatePaymentCardComponent)
    .component('messageTemplateCarouselCard', MessageTemplateCarouselCardComponent)
    .component('messageTemplateButtons', MessageTemplateButtonsComponent)
    .controller('ResourceController', ResourceController)
    .controller('MessageTemplateController', MessageTemplateController)
    .controller('CreateMessageTemplateSidebarController', CreateMessageTemplateSidebarController)
    .controller('MessageTemplateSampleModalController', MessageTemplateSampleModalController)
    .service('ResourceService', ResourceService)
    .service('MessageTemplateService', MessageTemplateService)
    .service('MessageTemplateUtil', MessageTemplateUtil)
    .service('MessageTemplateSegmentService', MessageTemplateSegmentService)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state(DETAIL_CONTENTS_PATH, {
            url: '/contents',
            redirectTo: DETAIL_CONTENTS_MESSAGE_TEMPLATES_PATH,
            data: {
                permissionClaim: permissions.resources.claim,
            },
            views: {
                'sidenav@auth.application.detail': {
                    template: ResourceMenuView,
                },
            },
            resolve: {
                checkLayout: AiAgentService.blockAiAgentAccess,
            },
            params: { area: 'resources' },
        })
            .state(DETAIL_CONTENTS_MESSAGE_TEMPLATES_PATH, {
            url: '/messagetemplate',
            views: {
                'content@auth.application.detail': {
                    template: MessageTemplateView,
                    controller: MessageTemplateController,
                    controllerAs: '$ctrl',
                },
            },
            data: { permissionClaim: permissions.resources.claim },
            params: { area: 'resources' },
        })
            .state(DETAIL_CONTENTS_RESOURCES_PATH, {
            url: '/resources',
            views: {
                'content@auth.application.detail': {
                    template: ResourceView,
                    controller: ResourceController,
                    controllerAs: '$ctrl',
                },
            },
            data: { permissionClaim: permissions.resources.claim },
            params: { area: 'resources' },
        });
    }]).name;
